import { Box, Container, Text, useColorModeValue } from '@chakra-ui/react';

function SeoDescription() {
    const bg = useColorModeValue('blue.50', 'whiteAlpha.50');
    const textColor = useColorModeValue('gray.700', 'gray.300');

    return (
        <Box bg={bg} py={4} mb={6} borderRadius="md">
            <Container maxW="container.xl">
                <Text
                    fontSize="sm"
                    color={textColor}
                    textAlign="center"
                    lineHeight="1.6"
                >
                    Free Splunk infrastructure sizing calculator for Enterprise and Cloud deployments.
                    Calculate storage requirements, indexer capacity, search head clusters, and hardware
                    resources based on daily data volume, retention policies, and premium apps (ES, ITSI, SOAR).
                    Get accurate sizing recommendations for on-premises and cloud architectures.
                </Text>
            </Container>
        </Box>
    );
}

export default SeoDescription;
